import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PDFViewer from '../components/PDFViewer';

const ProjectDetail = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();

  // Project mapping
  const projectMap = {
    'customer-centric-loyalty': {
      title: 'Customer-Centric Loyalty & Retention',
      pdfPath: '/assets/projects/Customer-Centric Loyalty & Retention.pdf',
      description: 'Transformation Assessment: Combine currently fragmented customer touchpoints into a unified Global Umbrella Offering, One Auto Shop & Buy | Ownership | Charging | Care & Service'
    },
    'e2e-process-assessment': {
      title: 'E2E Process Assessment',
      pdfPath: '/assets/projects/E2E Content Management Assessment.pdf',
      description: 'Design Thinking Assessment to effectively scale a Customer Program'
    },
    'freight-electrification': {
      title: 'Freight Electrification Analysis',
      pdfPath: '/assets/projects/7.1.2024 Freight Market Electrification Analysis.pdf',
      description: 'Electrification Assessment on how a client can effectively electrify their Freight Supply Chain to decarbonize emissions, lower costs, and streamline operations'
    },
    'apple-carplay-cx': {
      title: 'Apple CarPlay CX Review',
      pdfPath: '/assets/projects/Design Review - Apple CarPlay Homescreen in Sensus.pdf',
      description: 'Analyzing the User Experience of CarPlay\'s Home Screen using Apple\'s CarPlay Developer Guidelines'
    },
    'gtm-strategy-ai': {
      title: 'GTM Strategy: Generative AI Product',
      pdfPath: '/assets/projects/C3 Generative AI - Sales Co-Pilot.pdf',
      description: 'Defining the Go-to-Market Strategy for a new Generative AI product for Sales & Marketing: Sales Co-Pilot'
    },
    'uber-global-strategy': {
      title: 'Uber Global Strategy Analytics Case',
      pdfPath: '/assets/projects/Uber Global Strategy Analytics Case v2.pdf',
      description: 'Strategic analytics and business case development for Uber\'s global expansion'
    }
  };

  const project = projectMap[projectId];

  if (!project) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-primary-900 mb-4">Project Not Found</h1>
          <button
            onClick={() => navigate('/projects')}
            className="btn-primary"
          >
            Back to Projects
          </button>
        </div>
      </div>
    );
  }

  const handleBack = () => {
    navigate('/projects');
  };

  return (
    <PDFViewer
      pdfPath={project.pdfPath}
      projectTitle={project.title}
      onBack={handleBack}
    />
  );
};

export default ProjectDetail; 